import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M16 21h-4","key":"svg-0"}],["path",{"d":"M14 21v-18","key":"svg-1"}],["path",{"d":"M14 4l-9 4l9 4","key":"svg-2"}]]

/**
 * IconPennant2
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItcGVubmFudC0yIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xNiAyMWgtNCIgLz4KICA8cGF0aCBkPSJNMTQgMjF2LTE4IiAvPgogIDxwYXRoIGQ9Ik0xNCA0bC05IDRsOSA0IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/pennant-2
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconPennant2 = createReactComponent('outline', 'pennant-2', 'Pennant2', __iconNode);

export default IconPennant2;